var _api_root = "https://sajj.jlntech.cn/sajj/gthmmc/index.php";
/* var _api_root = "http://localhost/sajj/gthmmc/index.php"; */
/* var _api_root = "http://192.168.0.187/sajj/gthmmc/index.php"; */
var api = {
  get: {
    getlist: _api_root + "?m=ias&c=temp&a=getMemberList",
    getdwb: _api_root + "?m=ias&c=temp&a=getrank&showtype=2&department",
    getsb: _api_root + "?m=ias&c=temp&a=getrank&showtype=9&department",
    getxb: _api_root + "?m=ias&c=temp&a=getrank&showtype=10&department",
    getphb:
      _api_root + "?m=ias&c=manager&a=getPaihang&from=xcx&destination_id=499",
    getpro: _api_root + "?m=ias&c=temp&a=getrank&showtype=3",
  },

  post: {
    xgword: _api_root + "?m=ias&c=temp&a=modifyDepartment",
  },
};
export default api;
